
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isAddButton?: boolean;
}

export function ButtonSecundario({
  isAddButton,
  className,
  disabled,
  children,
  ...props
}: Props) {
  return (
    <button
      type="button"
      className={`h-8 w-full transition-colors items-center rounded-md border text-white 
        bg-zinc-600 
        ${isAddButton ? 'hover:border-green-600' : 'hover:border-blue-600'} 
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        active:bg-white active:text-black active:font-extrabold
        hover:bg-black ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}


export default ButtonSecundario;
